var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4021 425.264C27.4021 373.016 37.6931 321.28 57.6876 273.009C77.682 224.738 106.988 180.878 143.933 143.933C180.878 106.988 224.738 77.6818 273.009 57.6873C321.28 37.6929 373.017 27.4019 425.265 27.4019L425.265 425.264L27.4021 425.264Z",
    fill: "url(#paint0_linear_61_26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.265 27.4014C477.513 27.4014 529.249 37.6924 577.52 57.6869C625.791 77.6813 669.651 106.988 706.596 143.933C743.541 180.878 772.847 224.738 792.842 273.008C812.836 321.279 823.127 373.016 823.127 425.264L425.265 425.264L425.265 27.4014Z",
    fill: "url(#paint1_linear_61_26)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M425.265 823.127C373.017 823.127 321.28 812.836 273.009 792.842C224.738 772.847 180.878 743.541 143.933 706.596C106.988 669.651 77.6821 625.791 57.6877 577.52C37.6932 529.249 27.4022 477.513 27.4022 425.265L425.265 425.265L425.265 823.127Z",
    fill: "url(#paint2_linear_61_26)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.264C823.127 477.512 812.836 529.248 792.842 577.519C772.847 625.79 743.541 669.65 706.596 706.595C669.651 743.54 625.791 772.846 577.52 792.841C529.249 812.835 477.513 823.126 425.265 823.126L425.265 425.264L823.127 425.264Z",
    fill: "url(#paint3_linear_61_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_26",
    x1: 179.045,
    y1: 458.056,
    x2: 352.276,
    y2: -11.4221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_26",
    x1: 416.361,
    y1: 174.113,
    x2: 771.276,
    y2: 425.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_26",
    x1: 458.057,
    y1: 671.484,
    x2: 230.868,
    y2: 647.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_26",
    x1: 424.776,
    y1: 774.078,
    x2: 699.776,
    y2: 425.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors4);
export default __webpack_public_path__ + "static/media/sectors-4.736a3d4eda2f55c5cdbeac13a8165f04.svg";
export { ForwardRef as ReactComponent };